// Task #1472 — derived source category for Ad Library (My Ads) entries.
// Categories are DERIVED from existing generated_ads fields (no schema
// changes, no backfill):
//   - mediaType "slideshow"  -> slideshows
//   - mediaType "video"      -> videos
//   - slideshow marker (the "slideshow-express" tag and/or the
//     "Slideshow Express — " snapshot prefix the slideshow save routes
//     stamp; also covers single-slide IMAGE saves) -> slideshows
//   - meme marker (the "meme" tag written by the meme save route, and/or
//     the "Meme — " ad-unit-name-snapshot prefix it stamps) -> memes
//   - everything else (Ads Express, KC, Creative Tinder, instant ads,
//     edits, reframes) -> ads

export type LibraryCategory = "ads" | "memes" | "slideshows" | "videos";

export const LIBRARY_CATEGORIES: Array<{ id: LibraryCategory; label: string }> = [
  { id: "ads", label: "Ads" },
  { id: "memes", label: "Memes" },
  { id: "slideshows", label: "Slideshows" },
  { id: "videos", label: "Videos" },
];

export const MEME_SNAPSHOT_PREFIX = "Meme — ";
export const SLIDESHOW_SNAPSHOT_PREFIX = "Slideshow Express — ";
export const SLIDESHOW_TAG = "slideshow-express";

export function isLibraryCategory(v: unknown): v is LibraryCategory {
  return v === "ads" || v === "memes" || v === "slideshows" || v === "videos";
}

export function libraryCategoryOf(row: {
  mediaType?: string | null;
  tags?: string[] | null;
  adUnitNameSnapshot?: string | null;
}): LibraryCategory {
  if (row.mediaType === "slideshow") return "slideshows";
  if (row.mediaType === "video") return "videos";
  const tags = Array.isArray(row.tags) ? row.tags : [];
  const snapshot = row.adUnitNameSnapshot ?? "";
  // Single-slide saves from Slideshow Express are IMAGE rows but still
  // belong under Slideshows (checked before memes; markers never co-occur
  // in practice, but the order here must match the SQL in storage).
  if (tags.includes(SLIDESHOW_TAG) || snapshot.startsWith(SLIDESHOW_SNAPSHOT_PREFIX)) {
    return "slideshows";
  }
  if (tags.includes("meme") || snapshot.startsWith(MEME_SNAPSHOT_PREFIX)) {
    return "memes";
  }
  return "ads";
}
